import Box from "@mui/material/Box";

import {
  OutputFormat,
  SetCheckedItems,
  setOutputFormat,
} from "pages/geoscape-batch/models";
import React from "react";

import CustomTable from "components/shared/table";
import { BatchConfigProps } from "pages/geoscape-batch/types";
import { buildColumns } from "./columns-row";
import "./style.css"; // Import your CSS file

type Props = {
  props: BatchConfigProps;
  setCheckedItems: SetCheckedItems;
  enrichmentRows: OutputFormat[];
  setEnrichmentRows: setOutputFormat;
};

type PropsTable = {
  setCheckedItems: SetCheckedItems;
  enrichmentRows: OutputFormat[];
  setEnrichmentRows: setOutputFormat;
};

const MappingTableEnrichment = ({
  props,
  setCheckedItems,
  enrichmentRows,
  setEnrichmentRows,
}: Props) => {
  const headers: OutputFormat[] = enrichmentRows;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          height: "100%",
          marginTop: "16px",
        }}
      >
        {headers && (
          <DataTable
            enrichmentRows={enrichmentRows}
            setEnrichmentRows={setEnrichmentRows}
            setCheckedItems={setCheckedItems}
          />
        )}
      </Box>
    </>
  );
};

function DataTable({
  enrichmentRows,
  setEnrichmentRows,
  setCheckedItems,
}: PropsTable) {
  const [loading] = React.useState(false);

  const columns = buildColumns({
    enrichmentRows,
    setEnrichmentRows,
    setCheckedItems,
  });

  function getRowId(row: OutputFormat) {
    return row.source;
  }

  return (
    <CustomTable
      rows={enrichmentRows}
      columns={columns}
      isLoading={loading}
      getRowId={getRowId}
      pagination={false}
      overlayText={""}
    />
  );
}

export default MappingTableEnrichment;
